module.exports = __webpack_public_path__ + "img/icon_enjoy01@2x.86d8bc4f.png";